var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._t("default",[_vm._v("No "+_vm._s(_vm.rowName)+" to show ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }